import { Component } from '@angular/core';
import * as moment from 'moment/moment';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  year: string;

  constructor() {
    this.year = moment(new Date()).format('YYYY');
  }
  
}
